import React, { useState } from 'react'
import { Formik, Field } from 'formik'
import { Grid } from '@material-ui/core'
import { makeStyles, Theme } from '@material-ui/core/styles'
import LiquidSelectAdapter from '@src/components/LiquidSelectAdapter'
import { FormattedMessage, useIntl } from 'react-intl'
import messages from '../../messages'
import {
  getALLValue,
  setStandardTubeModificationData,
  modificationTypeWithPropertyKeys,
} from './ModificationResponse'
import { configContext } from '../../utils/StandardReducer'
import ValidationErrors from '@src/routes/Configurators/validations/ValidationErrors'
import { TubeProperties, CountryType, TubeProduct } from '../../utils/enum'
import clsx from 'clsx'
import InfoIcon from '@material-ui/icons/Info'
import styles from '@src/routes/Configurators/utils/styles'
import { checkValidKey } from '@src/routes/Configurators/utils/util'

const INITIAL_VALUES = {
  fiveModCategory: 'ALL',
  fiveMod: '',
  threeModCategory: 'ALL',
  threeMod: '',
}

export enum DefaultValue {
  Select = 'Select',
  All = 'ALL',
  ThreeModification = 'threeMod',
  FiveModiFication = 'fiveMod',
}

const useStyles = makeStyles((theme: Theme) => {
  return {
    fieldLabel: {
      '& label': {
        fontWeight: 'bold',
        fontSize: theme.typography.pxToRem(14),
        minHeight: 14,
      },
    },
    helpText: {
      fontSize: theme.typography.pxToRem(14),
      fontWeight: theme.typography.fontWeightMedium,
      marginLeft: theme.spacing(1),
    },
    helpLink: {
      color: theme.palette.primary.main,
    },
    margin: {
      marginTop: theme.spacing(5),
    },
  }
})

const SequenceModifications = (props) => {
  const classes = useStyles()
  const GlobalCSS = styles()
  const { modificationResponseData, productDetails } = props
  const [fiveModeValue, setFiveModeValue] = useState(DefaultValue.All)
  const [threeModeValue, setThreeModeValue] = useState(DefaultValue.All)
  const [threeModeValueType, setThreeModeValueType] = useState<string>(
    DefaultValue.Select
  )
  const [fiveModeValueType, setFiveModeValueType] = useState<string>(
    DefaultValue.Select
  )
  const { state, dispatch } = React.useContext(configContext)
  const {
    sessionData,
    currentOligoIndex,
    isSequenceValid,
    fiveModError,
    threeModError,
    fiveModThreeModErr,
  } = state
  const intl = useIntl()
  const email = intl.formatMessage(
    messages.PC_SEND_FEASIBLITY_AND_QUOTATION_REQUEST
  )
  const handleDropDownSelect = (event) => {
    const { name, value } = event.target

    if (name === 'fiveModCategory') {
      setFiveModeValue(event.target.value)
      setFiveModeValueType(DefaultValue.Select)
    } else {
      setThreeModeValue(event.target.value)
      setThreeModeValueType(DefaultValue.Select)
    }
    sessionData[currentOligoIndex][name] = value
    dispatch({
      type: 'UPDATE_INPUT',
      data: [...state.sessionData],
    })
  }

  const handleDropDown = (event) => {
    const { name, value } = event.target
    let errorDataValue = ''
    if (name === 'fiveMod') {
      setFiveModeValueType(value)
    } else {
      setThreeModeValueType(value)
    }
    if (value !== 'Select') {
      sessionData[currentOligoIndex][name] = value
      errorDataValue = value
    } else {
      sessionData[currentOligoIndex][name] = ''
      errorDataValue = ''
    }
    dispatch({ type: 'SET_ERROR_ICON', data: false })
    dispatch({
      type: 'UPDATE_INPUT',
      data: [...state.sessionData],
    })
    dispatch({
      type: 'UPDATE_ERROR_DATA',
      data: { ...state.errorData, [name]: errorDataValue },
    })
    dispatch({
      type: 'IS_CONFIRM_ORDER',
      data: false,
    })
  }

  const isSeqValid = (sessionData) => {
    if (isSequenceValid) {
      return false
    }
    if (!isSequenceValid) {
      const seq = sessionData[currentOligoIndex].sequence
      if (seq) {
        for (let i = 0; i < seq.length; i++) {
          if (seq.charAt(i) === '[') {
            for (let j = i + 1; j < seq.length; j++) {
              if (seq.charAt(j) === ']') {
                return false
              }
            }
          }
        }
      }
    }
    return true
  }

  const handleDisabled = () => isSeqValid(sessionData)

  React.useEffect(() => {
    if (state.isPageLoad === 4) {
      const { fiveMod, threeMod } = sessionData[currentOligoIndex]

      if (fiveMod && fiveMod !== '' && fiveMod !== undefined) {
        setFiveModeValueType(fiveMod.replace(/[[\]]/g, ''))
      } else {
        setFiveModeValueType(DefaultValue.Select)
        setFiveModeValue(DefaultValue.All)
      }

      if (threeMod && threeMod !== '' && threeMod !== undefined) {
        setThreeModeValueType(threeMod.replace(/[[\]]/g, ''))
      } else {
        setThreeModeValueType(DefaultValue.Select)
        setThreeModeValue(DefaultValue.All)
      }

      dispatch({
        type: 'UPDATE_PAGE_LOAD',
        data: 3,
      })
    }
    // TODO: need a test before we refactor these dependencies
  }, [state.isPageLoad])

  return (
    <Formik
      initialValues={INITIAL_VALUES}
      onSubmit={(values, actions) => {
        setTimeout(() => {
          actions.setSubmitting(false)
        }, 1000)
      }}
    >
      {({ setFieldValue }) => (
        <>
          <Grid container spacing={10}>
            {productDetails.productType === TubeProduct.iscaledna ? (
              <Grid item xs={12} sm={4} className={classes.fieldLabel}>
                <Field
                  name="fiveMod"
                  component={LiquidSelectAdapter}
                  value={fiveModeValueType}
                  disabled={handleDisabled()}
                  onChange={(e) => {
                    setFieldValue('fiveMod', e.target.value)
                    handleDropDown(e)
                  }}
                  onBlur={(event) => {
                    if (!event) return
                  }}
                  options={[
                    {
                      label: DefaultValue.Select,
                      value: DefaultValue.Select,
                    },
                    ...getALLValue(
                      DefaultValue.FiveModiFication,
                      fiveModeValue,
                      modificationResponseData,
                      state.errorResponseJson,
                      sessionData[state.currentOligoIndex].isOverridden
                    ),
                  ]}
                  displayEmpty
                  renderValue={() => {
                    let fiveModOptions: {
                      label: string
                      value: string
                    }[] = []
                    fiveModOptions = setStandardTubeModificationData(
                      DefaultValue.FiveModiFication,
                      fiveModeValue,
                      modificationResponseData
                    )
                    const option = fiveModOptions.find((obj) => {
                      return (
                        obj.value === sessionData[currentOligoIndex].fiveMod
                      )
                    })
                    let newLabel = ''
                    if (option && option.label) {
                      newLabel = checkValidKey(
                        messages[option.label],
                        option.label
                      ).defaultMessage
                    }
                    return newLabel || fiveModeValueType
                  }}
                  label={<FormattedMessage {...messages.CONF_5_MOD_standard} />}
                  data-testid="status-input"
                  id="status-input"
                  filled
                />
              </Grid>
            ) : (
              <>
                <Grid item xs={12} sm={4} className={classes.fieldLabel}>
                  <Field
                    name={'fiveModCategory'}
                    component={LiquidSelectAdapter}
                    label={
                      <FormattedMessage {...messages.CONF_5_MOD_standard} />
                    }
                    options={[
                      {
                        label: DefaultValue.All,
                        value: DefaultValue.All,
                      },
                      ...modificationTypeWithPropertyKeys(
                        DefaultValue.FiveModiFication,
                        modificationResponseData
                      ),
                    ]}
                    value={fiveModeValue}
                    onChange={(e) => {
                      setFieldValue('fiveModCategory', e.target.value)
                      handleDropDownSelect(e)
                    }}
                    disabled={isSeqValid(sessionData)}
                    filled
                  />
                </Grid>
                <Grid item xs={12} sm={4} className={classes.fieldLabel}>
                  <Field
                    name="fiveMod"
                    component={LiquidSelectAdapter}
                    value={fiveModeValueType}
                    disabled={handleDisabled()}
                    onChange={(e) => {
                      setFieldValue('fiveMod', e.target.value)
                      handleDropDown(e)
                    }}
                    onBlur={(event) => {
                      if (!event) return
                    }}
                    options={[
                      {
                        label: DefaultValue.Select,
                        value: DefaultValue.Select,
                      },
                      ...getALLValue(
                        DefaultValue.FiveModiFication,
                        fiveModeValue,
                        modificationResponseData,
                        state.errorResponseJson,
                        sessionData[state.currentOligoIndex].isOverridden
                      ),
                    ]}
                    displayEmpty
                    renderValue={() => {
                      let fiveModOptions: {
                        label: string
                        value: string
                      }[] = []
                      fiveModOptions = setStandardTubeModificationData(
                        DefaultValue.FiveModiFication,
                        fiveModeValue,
                        modificationResponseData
                      )
                      const option = fiveModOptions.find((obj) => {
                        return (
                          obj.value === sessionData[currentOligoIndex].fiveMod
                        )
                      })
                      let newLabel = ''
                      if (option && option.label) {
                        newLabel = checkValidKey(
                          messages[option.label],
                          option.label
                        ).defaultMessage
                      }
                      return newLabel || fiveModeValueType
                    }}
                    label=" "
                    data-testid="status-input"
                    id="status-input"
                    filled
                  />
                </Grid>
              </>
            )}
          </Grid>
          <div>
            <ValidationErrors errors={fiveModError ? fiveModError : []} />
          </div>

          <Grid container spacing={10}>
            {productDetails.productType === TubeProduct.iscaledna ? (
              <Grid item xs={12} sm={4} className={classes.fieldLabel}>
                <Field
                  name="threeMod"
                  component={LiquidSelectAdapter}
                  value={threeModeValueType}
                  onChange={(e) => {
                    setFieldValue('threeMod', e.target.value)
                    handleDropDown(e)
                  }}
                  onBlur={(event) => {
                    if (!event) return
                  }}
                  options={[
                    {
                      label: DefaultValue.Select,
                      value: DefaultValue.Select,
                    },

                    ...getALLValue(
                      DefaultValue.ThreeModification,
                      threeModeValue,
                      modificationResponseData,
                      state.errorResponseJson,
                      sessionData[state.currentOligoIndex].isOverridden
                    ),
                  ]}
                  displayEmpty
                  renderValue={() => {
                    let threeModOptions: {
                      label: string
                      value: string
                    }[] = []
                    threeModOptions = setStandardTubeModificationData(
                      DefaultValue.ThreeModification,
                      threeModeValue,
                      modificationResponseData
                    )

                    const option = threeModOptions.find((obj) => {
                      return (
                        obj.value === sessionData[currentOligoIndex].threeMod
                      )
                    })
                    let newLabel = ''
                    if (option && option.label) {
                      newLabel = checkValidKey(
                        messages[option.label],
                        option.label
                      ).defaultMessage
                    }
                    return newLabel || threeModeValueType
                  }}
                  label={<FormattedMessage {...messages.CONF_3_MOD_standard} />}
                  disabled={handleDisabled()}
                  filled
                />
              </Grid>
            ) : (
              <>
                <Grid item xs={12} sm={4} className={classes.fieldLabel}>
                  <Field
                    name="threeModCategory"
                    component={LiquidSelectAdapter}
                    label={
                      <FormattedMessage {...messages.CONF_3_MOD_standard} />
                    }
                    options={[
                      {
                        label: DefaultValue.All,
                        value: DefaultValue.All,
                      },
                      ...modificationTypeWithPropertyKeys(
                        DefaultValue.ThreeModification,
                        modificationResponseData
                      ),
                    ]}
                    value={threeModeValue}
                    onChange={(e) => {
                      setFieldValue('threeModCategory', e.target.value)
                      handleDropDownSelect(e)
                    }}
                    data-testid="status-input"
                    id="status-input"
                    filled
                    disabled={handleDisabled()}
                  />
                </Grid>
                <Grid item xs={12} sm={4} className={classes.fieldLabel}>
                  <Field
                    name="threeMod"
                    component={LiquidSelectAdapter}
                    value={threeModeValueType}
                    onChange={(e) => {
                      setFieldValue('threeMod', e.target.value)
                      handleDropDown(e)
                    }}
                    onBlur={(event) => {
                      if (!event) return
                    }}
                    options={[
                      {
                        label: DefaultValue.Select,
                        value: DefaultValue.Select,
                      },

                      ...getALLValue(
                        DefaultValue.ThreeModification,
                        threeModeValue,
                        modificationResponseData,
                        state.errorResponseJson,
                        sessionData[state.currentOligoIndex].isOverridden
                      ),
                    ]}
                    displayEmpty
                    renderValue={() => {
                      let threeModOptions: {
                        label: string
                        value: string
                      }[] = []
                      threeModOptions = setStandardTubeModificationData(
                        DefaultValue.ThreeModification,
                        threeModeValue,
                        modificationResponseData
                      )

                      const option = threeModOptions.find((obj) => {
                        return (
                          obj.value === sessionData[currentOligoIndex].threeMod
                        )
                      })
                      let newLabel = ''
                      if (option && option.label) {
                        newLabel = checkValidKey(
                          messages[option.label],
                          option.label
                        ).defaultMessage
                      }
                      return newLabel || threeModeValueType
                    }}
                    label=" "
                    disabled={handleDisabled()}
                    filled
                  />
                </Grid>
              </>
            )}
          </Grid>
          <div>
            <ValidationErrors errors={threeModError ? threeModError : []} />
          </div>
          <div>
            <ValidationErrors
              errors={fiveModThreeModErr ? fiveModThreeModErr : []}
            />
          </div>
          <div className={classes.margin}>
            {
              <Grid container className={GlobalCSS.noteInfo}>
                <Grid item xs={1} className={GlobalCSS.InfoText}>
                  <InfoIcon
                    aria-label="info"
                    className={GlobalCSS.InfoIcon}
                    color="primary"
                  ></InfoIcon>
                </Grid>
                <Grid item xs={11}>
                  <FormattedMessage
                    {...messages.PC_SEND_FEASIBLITY_AND_QUOTATION_MSG}
                  />
                  {productDetails.countryCode !== CountryType.cpeptideJapan ? (
                    <a href={`mailto:${email}`}>
                      <span
                        className={clsx(classes.helpText, classes.helpLink)}
                      >
                        <FormattedMessage
                          {...messages.PC_SEND_FEASIBLITY_AND_QUOTATION_REQUEST}
                        />
                      </span>
                    </a>
                  ) : (
                    <a href={`mailto:${TubeProperties.cpeptideJPEmail}`}>
                      <span
                        className={clsx(classes.helpText, classes.helpLink)}
                      >
                        <FormattedMessage
                          {...messages.PC_CONTACT_JP_CPEPTIDE}
                        />
                      </span>
                    </a>
                  )}
                </Grid>
              </Grid>
            }
          </div>
        </>
      )}
    </Formik>
  )
}

export default SequenceModifications
